import iposApi from '../../api/iposApi';
import {currentDeliveryItem, orderTotal} from '../selectors/order';
import { collectOrderItems } from  '../actions/orderActions';

export const setValueCardInfo = data => ({
    type: 'SET_VALUE_CARD_INFO',
    data,
  });

export const setSelectedValueCardBenefits = (data) => ({
    type: "SET_SELECTED_VALUECARD_BENEFITS",
    data,
  });

export const setValueCardBenefitsResponse = (data) => ({
    type: "SET_VALUECARD_BENEFITS_RESPONSE",
    data,
  });

export const setValueCardItem = (data) => ({
    type: "SET_VALUECARD_ITEM",
    data,
  });

  export const loadValueCardInformation = (valueCardNumber) => async (dispatch, getState) => {
    const {branchInfo} = getState();
    const url = '/ValueCardInformation';
    const params = {
      branchId: branchInfo.branch_guid_code,
      cardNumber: valueCardNumber
    };
  
    try {
  
      const response = await iposApi.get(url, {params});
      return response.data;
  
    } catch (error) {
      dispatch(() => ({type: 'ERROR', data: error}));
    }
  };

  export const valueCardGetBenefitsQuery = () => async (dispatch, getState) => {
    const state = getState();
    const {
      branchInfo,
      orderItems,
      orderGuidCode,
      valuecardInfo,
      selectedValueCardBenefits,
    } = state;

    const deliveryItem = currentDeliveryItem(state);

    let orderData = {};
    orderData.order_guid_code = orderGuidCode;    
    orderData.branch_id = branchInfo.branch_guid_code;    
    orderData.order_items = collectOrderItems(orderItems);
    orderData.order_amount = orderTotal(state);
    orderData.valuecard_number = valuecardInfo.memberCardNumber;
    orderData.benefits = selectedValueCardBenefits;

    if (deliveryItem) {
      orderData.order_items.push(deliveryItem.orderItem);
    }

    const url = "/ValueCardGetBenefitsQuery";

    try {
      const response = await iposApi.post(url, orderData);
      return await response.data;
    } catch (error) {
      dispatch(() => ({ type: "ERROR", data: error }));
    }
  };